/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ListWorkflows from '@jira/admin-pages__list-workflows/src/ListWorkflows.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyListWorkflows: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ListWorkflows
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-list-workflows", jiraSpaEntry: "async-admin-pages-list-workflows" */ '@jira/admin-pages__list-workflows/src/ListWorkflows.tsx'
		),
	),
);

const AsyncListWorkflows = (): React.JSX.Element => (
	<LazyPage Page={LazyListWorkflows} pageId="jira-admin-pages-list-workflows" shouldShowSpinner />
);

export default AsyncListWorkflows;
